import { useState, useEffect } from "react";

/**
 * Hook to manage open/close state with optional localStorage persistence
 * @param stateName optional name for the state to be stored in localStorage
 */
const useOpenClose = (initialState = false, stateName? : string) => {
    const getInitialState = (): boolean => {
        if (stateName) {
            const storedState = localStorage.getItem(stateName);
            if (storedState !== null) {
                return JSON.parse(storedState);
            }
        }
        return !!initialState;
    };

    const [isOpen, setIsOpen] = useState(stateName ? getInitialState : initialState);

    useEffect(() => {
        if (stateName) {
            localStorage.setItem(stateName, JSON.stringify(isOpen));
        }
    }, [isOpen, stateName]);

    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);
    const toggle = () => setIsOpen(prev => !prev);

    return { isOpen, open, close, toggle };
};

export default useOpenClose;